import { jsx as o, Fragment as c, jsxs as p } from "react/jsx-runtime";
import { useCallback as m } from "react";
import { MenuItem as g } from "../menu-item/index.js";
import t from "./styles.module.less.js";
import { DropdownMenuItemMobile as u } from "../dropdown-menu-item/index.js";
import w from "./billing-history.svg.js";
import d from "./world.svg.js";
const I = (a) => {
  const { getTranslation: e, language: r, isScrolledHeader: n, isActive: s } = a, i = m(() => {
    window.location.href = `/${r}/for-lawyers/legal-network`;
  }, [r]);
  return /* @__PURE__ */ o(
    g,
    {
      label: e("register.for-lawyers"),
      chevronStyle: "rotate",
      hasShrunk: n,
      isActive: s,
      onClick: i,
      classNames: {
        wrapper: t.buttonWrapper,
        childContainer: `${t.hoverMenu} ${n ? t.scrolledHeader : ""}`
      },
      children: /* @__PURE__ */ o(c, { children: [
        {
          path: `/${r}/for-lawyers/legal-network`,
          title: e("about.menu.legal-network"),
          icon: /* @__PURE__ */ o(d, { className: t.menuIcon })
        },
        {
          path: `/${r}/for-lawyers/sign-up`,
          title: e("pages.sign-up"),
          icon: /* @__PURE__ */ o(w, { className: t.menuIcon })
        }
      ].map((l) => /* @__PURE__ */ p("a", { href: l.path, className: t.menuItem, children: [
        /* @__PURE__ */ o("span", { className: `${t.menuItemText}`, children: l.title }),
        l.icon
      ] }, l.title)) })
    }
  );
}, N = (a) => {
  const { getTranslation: e, language: r, classNames: n } = a;
  return /* @__PURE__ */ o(
    u,
    {
      language: r,
      titleLabel: e("register.for-lawyers"),
      link: `/${r}/for-lawyers/legal-network`,
      items: [
        {
          title: e("about.menu.legal-network"),
          description: e("register.legal-network-description"),
          path: `/${r}/for-lawyers/legal-network`
        },
        {
          title: e("pages.sign-up"),
          description: e("register.register-interest-description"),
          path: `/${r}/for-lawyers/sign-up`
        }
      ],
      classNames: n
    }
  );
};
export {
  I as ForLawyersMenuButtonDesktop,
  N as ForLawyersMenuButtonMobile
};
